import './GamingLibrary.css'
import {GamingLibraryCard, SectionHeader,SectionWrapper} from '../../components/index'
import GamingLibData from '../../Data/GamingLibData'
const GamingLibrary = () => {

  const cards = GamingLibData.map(card => {
    return <GamingLibraryCard key={card.id} img={card.img} title={card.title} date_added={card.date_added}category={card.category} download={card.download} />
   })
   

  return (
    <SectionWrapper>
    <SectionHeader>Gaming Library</SectionHeader>
      <div className='gaming-library-cards'>
     {cards}

        

       
      </div>
    
 </SectionWrapper>
  )
}

export default GamingLibrary